import { CheckCircleOutlined } from '@ant-design/icons'
import { isNewOpen } from '@util'
import { Modal } from 'hljd'
import React from 'react'

const successModal = data => {
  let info = {
    title: '案例编辑成功，等待审核结果',
    width: 500,
    content: (
      <div style={{ width: '375px' }}>
        <pre
          style={{
            color: '#666',
            lineHeight: '22px',
            marginTop: '4px',
            whiteSpace: 'break-spaces',
            fontFamily: 'inherit'
          }}
        >
          {data.tips}
        </pre>
        {data?.editLimitTip && (
          <p style={{ color: '#f00' }}>{data?.editLimitTip}</p>
        )}
        <img
          style={{
            width: '135px',
            margin: '32px auto 0 auto',
            display: 'block'
          }}
          src={data.service_qrcode || data.serviceQrcode}
        />
        <p style={{ color: '#333', marginTop: '14px', textAlign: 'center' }}>
          微信扫码查看审核结果
        </p>
      </div>
    ),
    onOk: () => {
      window.location.href = '#/localMerchant/case'
    }
  }

  isNewOpen()
    ? Modal.confirm({
        icon: (
          <CheckCircleOutlined style={{ color: '#2FC286', fontSize: 20 }} />
        ),
        ...info,
        okText: '立即查看',
        cancelText: '继续其他开店任务',
        onCancel: () => {
          window.location.href = '#/localMerchant/home'
        }
      })
    : Modal.success({
        ...info
      })
}

export default successModal
